
import Component from 'vue-class-component';
import NonCommodityPrototype from '@/main/NonCommodityPrototype.vue';
import WidgetsList from '@/interfaces/WidgetsList';
import NonCommodityStep from '@/models/NonCommodityStep';
import IocContainer from '@/container/IocContainer';
import SERVICES from '@/container/Services';
import Api from '@/interfaces/Api';
import { Watch } from 'vue-property-decorator';

const ApiProvider = IocContainer.get<Api>(SERVICES.API);

@Component({
  props: {
    ...{
      partner: String,
      fleet: String
    }
  }
})
export default class ElliThgPrototype extends NonCommodityPrototype {
  public widgetsList: WidgetsList = {
    product: true,
    registration: false,
    contract: false,
    review: false,
    disabled: {
      product: false,
      registration: true,
      contract: true,
      review: true
    }
  };

  public afterSessionCreation(): void {
    this.setPartnerInformation();
  }

  get isFleet(): boolean {
    if (process.env.VUE_APP_IS_FLEET) {
      return true;
    }
    return !!(this.$props.fleet && this.$props.fleet != 'false');
  }

  @Watch('isFleetFlow')
  public handleFleetFlow(): void {
    if (this.isFleetFlow) {
      this.startFleetFlow();
    }
  }

  protected getPartnerFromParameters(): string | null {
    let partner: string | null = null;
    let urlParams = new URLSearchParams(window.location.search);
    let urlParamPartner = urlParams.has('partner') ? urlParams.get('partner') : null;

    if (urlParamPartner && urlParamPartner.length > 0) {
      partner = urlParamPartner;
    } else if (this.$props.partner) {
      partner = this.$props.partner;
    }
    return partner;
  }

  protected setPartnerInformation(): void {
    const partner = this.getPartnerFromParameters();
    if (partner) {
      const extendedData = {
        [this.extendedDataParentKey]: {
          PROVISIONCONTRACT_MULTI: partner.toString()
        }
      };

      const data = {
        vpCode: partner,
        extendedData: JSON.stringify(extendedData)
      };
      ApiProvider.sessionUpdate(data);
      this.store.dispatch('setSessionExtendedData', extendedData);
      this.store.dispatch('setContactData', { vpCode: partner });
    }
  }

  protected get extendedDataParentKey(): string {
    return 'THG_MULTIYEAR';
  }

  protected stepStates: NonCommodityStep[] = [
    NonCommodityStep.withData({
      widget: 'product',
      title: this.$t('stepper.noncommodity.product').toLocaleString(),
      stepHeader: 'noncommodity.product.header',
      stepDescription: '',
      iconPending: 'non-commodity-icon-reward',
      iconComplete: 'non-commodity-icon-done',
      isShown: true
    }),
    NonCommodityStep.withData({
      widget: 'registration',
      title: this.$t('stepper.noncommodity.registration').toLocaleString(),
      description: '',
      iconPending: 'non-commodity-icon-registration'
    }),
    NonCommodityStep.withData({
      widget: 'contract',
      title: this.$t('stepper.contract').toLocaleString(),
      description: '',
      iconPending: 'non-commodity-icon-data'
    }),
    NonCommodityStep.withData({
      widget: 'review',
      title: this.$t('stepper.noncommodity.finalize').toLocaleString(),
      iconPending: 'non-commodity-icon-check-data'
    })
  ];

  public startFleetFlow(): void {
    this.stepStates = [
      NonCommodityStep.withData({
        widget: 'product',
        title: this.$t('stepper.noncommodity.product').toLocaleString(),
        stepHeader: 'noncommodity.product.header',
        stepDescription: '',
        iconPending: 'non-commodity-icon-reward',
        iconComplete: 'non-commodity-icon-done',
        isShown: true
      }),
      NonCommodityStep.withData({
        widget: 'contract',
        title: this.$t('stepper.contract').toLocaleString(),
        description: '',
        iconPending: 'non-commodity-icon-data'
      }),
      NonCommodityStep.withData({
        widget: 'review',
        title: this.$t('stepper.noncommodity.finalize').toLocaleString(),
        iconPending: 'non-commodity-icon-check-data'
      })
    ];
  }

  protected async productSubmit(): Promise<void> {
    return await this.loadAddons();
  }
}
